import * as DEBUGLOG from "../../../components/util/debugLog";
import requestTimer from "../../requestTimer";
import tabChangeListener from "../../../utils/listeners/TabChangeListener";
import participationUrl from "../participationUrl";

const shortName = async (body) => {
  tabChangeListener.setWaitingForApi("complete");
  let completeRequestDate = DEBUGLOG.debugLogRequestStart("complete");
  let response = await fetch(
    participationUrl() + "/participation/shortname_login",
    {
      method: "POST",
      body: JSON.stringify(body),
    }
  );

  DEBUGLOG.debugLogRequestFinish(completeRequestDate);

  if (response.ok) {
    let responseBody = await response.json();
    tabChangeListener.setWaitingForApi("");
    return responseBody;
  } else {
    let e = new Error(response.statusText);
    e.name = response.status || "";
    throw e;
  }
};

export default (...args) => requestTimer(() => shortName(...args));
